import { useFormik } from "formik";
import { useEffect, useState } from "react";
import axiosInstance from "../../Services/axiosCommon";
import { useToast } from "../Others/ToastServices";
import { NuInputSetting } from "../Utils/Input";
import { TextMediumXS } from "../Text/MediumText";

const SettingsMetaData = ({ propertyName, viewPropertyName }) => {
  const [data, setData] = useState([]);
  const toast = useToast();
  const [createNew, setCreateNew] = useState({
    property: `${propertyName}`,
    value: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      axiosInstance
        .post(`/dropdown/create-dropdown`, value)
        .then((res) => {
          if (res.data) {
            resetForm();
            GetData();
            toast.open({
              type: "success",
              message: `${createNew?.property} Added successfully`,
            });
          } else {
            toast.open({
              type: "error",
              message: `${createNew?.property} Add failed`,
            });
          }
        });
    },
  });

  const GetData = async () => {
  try {
    const res = await axiosInstance.get(`/dropdown/dropdown-details/${createNew?.property}`);
    let result = res.data?.data[createNew?.property];
    if (result) {
      let sortedData = result.sort((a, b) =>
        a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1
      );
      setData(sortedData);
    }
  } catch (error) {
    console.error("API call failed:", error);
    toast.open({
      type: "error",
      message: "Failed to fetch data. Check your server connection.",
    });
  }
};


  const handleDelete = (value) => {
    axiosInstance
      .delete(`/dropdown/remove-value/${createNew?.property}/${value}`)
      .then((res) => {
        if (res?.status === 200) {
          GetData();
          toast.open({
            type: "success",
            message: `${createNew?.property} Deleted successfully`,
          });
        } else {
          toast.open({
            type: "error",
            message: `${createNew?.property} Delete failed`,
          });
        }
      });
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="w-full">
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full text-xs">
          <div className="px-3 mb-1">
            <label className="font-medium text-textColor-500 mb-1">
              {viewPropertyName}
            </label>
            <NuInputSetting
              type="text"
              placeholder={viewPropertyName}
              formik={formik}
              name="value"
            />
          </div>
        </div>
      </form>

      <div className="px-3">
        <div className="w-full rounded-lg h-44 bg-[#f5f3ff] border border-gray-300 overflow-x-hidden overflow-y-auto">
          <ul>
            {data.map((List, idx) => (
              <li
                className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50"
                key={idx}
              >
                <TextMediumXS
                  color={"text-[#697565]"}
                  content={List.value || "-"}
                />
                {List?.isDefault === true ? null : List?.value && (
                  <span
                    onClick={() => handleDelete(List?.value)}
                    className="text-blue-900 cursor-pointer"
                  >
                    x
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SettingsMetaData;
